import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { RegisterService } from '../../../services/Api'
import { ValidationService } from '../Utils/validation'
import { REGISTRATION_STEPS } from '../Common/validation'

export const useRegister = () => {
  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    password: "",
    password2: "",
    first_name: "",
    last_name: "",
    phone_number: "",
    referral_code: "",
  })
  const [loading, setLoading] = useState(false)
  const [errors, setErrors] = useState({})
  const [touched, setTouched] = useState({})
  const [step, setStep] = useState(REGISTRATION_STEPS.PERSONAL_INFO)
  const [showPassword, setShowPassword] = useState(false)
  const [showPassword2, setShowPassword2] = useState(false)

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
    
    if (touched[name]) {
      const error = ValidationService.validateField(name, value, formData)
      setErrors(prev => ({ ...prev, [name]: error }))
    }
  }

  const handleBlur = (e) => {
    const { name, value } = e.target
    setTouched(prev => ({ ...prev, [name]: true }))
    const error = ValidationService.validateField(name, value, formData)
    setErrors(prev => ({ ...prev, [name]: error }))
  }

  const nextStep = () => {
    const { isValid, errors: stepErrors } = ValidationService.validateStep(1, formData)
    
    if (isValid) {
      setStep(REGISTRATION_STEPS.CREDENTIALS)
      setErrors({})
      setTouched({})
    } else {
      setErrors(stepErrors)
      setTouched(['first_name', 'last_name', 'email'].reduce((acc, field) => ({ ...acc, [field]: true }), {}))
    }
  }

  const prevStep = () => {
    setStep(REGISTRATION_STEPS.PERSONAL_INFO)
    setErrors({})
    setTouched({})
  }

  const register = async () => {
    const { isValid, errors: stepErrors } = ValidationService.validateStep(2, formData)
    
    if (!isValid) {
      setErrors(stepErrors)
      setTouched(['username', 'phone_number', 'password', 'password2'].reduce((acc, field) => ({ ...acc, [field]: true }), {}))
      return
    }

    setLoading(true)

    try {
      const response = await RegisterService.register(formData)
      const { success, data, message } = response

      if (success && data) {
        RegisterService.storeUserSession(data)
        navigate("/profile")
      } else {
        setErrors({ general: message || "Registration failed. Please try again." })
      }
    } catch (err) {
      console.error("Registration error:", err.response?.data)
      if (err.response?.data?.message) {
        if (typeof err.response.data.message === "object") {
          setErrors(err.response.data.message)
        } else {
          setErrors({ general: err.response.data.message })
        }
      } else {
        setErrors({ general: "Failed to register. Please try again." })
      }
    } finally {
      setLoading(false)
    }
  }

  return {
    formData,
    loading,
    errors,
    touched,
    step,
    showPassword,
    showPassword2,
    handleChange,
    handleBlur,
    nextStep,
    prevStep,
    register,
    setShowPassword,
    setShowPassword2
  }
}
